import $ from 'jquery';

class CompareInsuranceDropdown {
  constructor() {
    this.hciDropdown = $('.js-hci-dropdown');

    if (!this.hciDropdown.length) {
      return;
    }

    this.dropdownToggler = this.hciDropdown.find('.js-hci-dropdown-toggle');
    this.dropdownInner = this.hciDropdown.find('.js-hci-dropdown-inner');

    this.dropdown();
  }

  dropdown() {
    this.dropdownToggler.on('click', () => {
      if (!this.dropdownInner.hasClass('is-open')) {
        this.dropdownInner.addClass('is-open');
        this.hciDropdown.addClass('has-dropdown-open');
        this.dropdownToggler.attr('aria-expanded', true);
      } else {
        this.dropdownInner.removeClass('is-open');
        this.hciDropdown.removeClass('has-dropdown-open');
        this.dropdownToggler.attr('aria-expanded', false);
      }
    });

    $(document).on('click', e => {
      const clickedElement = $(e.target);

      if (
        !clickedElement.hasClass('js-hci-dropdown-toggle') &&
        !clickedElement.closest('.js-hci-dropdown-inner').length
      ) {
        this.dropdownInner.removeClass('is-open');
        this.hciDropdown.removeClass('has-dropdown-open');
        this.dropdownToggler.attr('aria-expanded', false);
      }
    });
  }
}

export default new CompareInsuranceDropdown();



// WEBPACK FOOTER //
// ./src/scripts/modules/compare-insurance-dropdown.js